import React, { useState } from 'react';
import classNames from 'classnames';
import { Button } from 'reactstrap';
import '@fortawesome/fontawesome-free/css/all.min.css';

import styles from './styles.module.scss';
import { TYPE_EXPORT_PDF } from './../../constants';
import { HTTP_NOT_FOUND } from 'constants/StatusCode';
// import styled from 'styled-components';

// const Div = styled.div`
//   .btn-cancel {
//     color: #8d8d8d;
//     background: transparent;
//     border: none;
//     font-weight: 400 !important;
//     &:hover,
//     &:focus,
//     &:active {
//       background: transparent !important;
//       border: none !important;
//       color: #8d8d8d !important;
//       box-shadow: none !important;
//     }
//   }
//   .btn-ok {
//     color: #fea628;
//     background: transparent;
//     border: none;
//     font-weight: 500;
//     &:hover,
//     &:focus,
//     &:active {
//       background: transparent !important;
//       border: none !important;
//       color: #fea628 !important;
//       box-shadow: none !important;
//     }
//   }
// `;

const ButtonComponent = (props) => {
  const { icon, imgIcon, text, addClass, href, type, hasDisabled, isLoading} = props;
  const { apiLink, nameFile } = props;
  let _type = type;

  const [isDisable, setIsDisable] = useState(false);
  if (!_type) {
    _type = 'button';
  }

  const handleExport = async () => {
    setIsDisable(true);
    fetch(apiLink, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/pdf',
      },
    })
      .then((response) => {
        if (response.status === HTTP_NOT_FOUND) {
          return '';
        }
        return response.blob();
      })
      .then((blob) => {
        if (blob) {
          const url = window.URL.createObjectURL(new Blob([blob]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `${nameFile}.pdf`);
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
        }
        setIsDisable(false);
      })
      .catch((err) => {
        setIsDisable(false);
        console.log(err);
      });
  };

  const TagButton = () => {
    if (_type === TYPE_EXPORT_PDF) {
      _type = 'button';
      return (
        <Button
          type={_type}
          href={href}
          onClick={handleExport}
          disabled={isDisable}
          className={classNames(`${styles.ctButton} ${addClass}`)}
        >
          {imgIcon && <img src={imgIcon} alt={imgIcon} />}
          {icon && icon}
          {text}
          <i
            className={classNames(
              `fa fa-spinner fa-pulse fa-3x fa-fw ${isDisable ? '' : 'hidden'} ${styles.iconLoading}`,
            )}
          />
        </Button>
      );
    } else {
      return (
        <Button
          type={_type}
          href={href}
          onClick={props.handleClick}
          className={classNames(`${styles.ctButton} ${addClass}`)}
          disabled={hasDisabled}
        >
          {imgIcon && <img src={imgIcon} alt={imgIcon} />}
          {icon && icon}
          {text}
          <i
            className={classNames(
              `fa fa-spinner fa-pulse fa-3x fa-fw ${isLoading ? '' : 'hidden'} ${styles.iconLoading}`,
            )}
          />
        </Button>
      );
    }
  };

  return <TagButton />;
};

export default ButtonComponent;
